import React from "react";
import { FileDown, LockKeyhole, ShieldCheck } from "lucide-react";

export const DEMO_GATE_STATS = { access: 142, blocked: 7, lockedIPs: ["45.33.22.11", "103.44.55.66"] };

export function GateStatusCard({ stats, demo, onToggleDemo, onExport, exporting }) {
  return (
    <section
      className="relative mt-6 flex flex-col justify-between overflow-hidden rounded-xl border border-edge bg-void p-6"
      data-testid="gate-status-card"
    >
      <div className="absolute left-0 top-0 h-full w-1 bg-aegis-cyan/70" />
      <div>
        <div className="mb-4 flex items-center justify-between gap-3">
          <h3 className="font-mono text-sm text-slate-400">Zero-Trust Gate Status (24H)</h3>
          <button
            onClick={onToggleDemo}
            data-testid="gate-demo-toggle"
            className={`rounded-md border px-2 py-0.5 font-mono text-[10px] transition-colors ${
              demo
                ? "border-aegis-amber/40 bg-aegis-amber/10 text-aegis-amber"
                : "border-aegis-emerald/40 bg-aegis-emerald/10 text-aegis-emerald"
            }`}
          >
            {demo ? "DEMO DATA" : "LIVE LEDGER"}
          </button>
        </div>

        <div className="mb-4 flex items-end justify-between border-b border-edge pb-4">
          <div>
            <div className="mb-1 text-xs text-slate-400">已授权通行 (Access)</div>
            <div className="font-mono text-2xl tabular text-aegis-cyan" data-testid="gate-stat-access">
              {stats.access}
            </div>
          </div>
          <div className="text-right">
            <div className="mb-1 text-xs text-slate-400">暴力破解拦截 (Blocked)</div>
            <div className="font-mono text-2xl tabular text-aegis-red" data-testid="gate-stat-blocked">
              {stats.blocked}
            </div>
          </div>
        </div>

        <div className="mb-2 text-xs text-slate-400">活跃锁定 IP (15 minutes ban):</div>
        <div className="mb-4 space-y-1" data-testid="gate-locked-ips">
          {stats.lockedIPs.length ? (
            stats.lockedIPs.map((ip) => (
              <div
                key={ip}
                data-testid={`gate-locked-ip-${ip}`}
                className="flex items-center rounded border border-aegis-red/30 bg-aegis-red/10 px-2 py-1.5 font-mono text-xs text-aegis-red"
              >
                <LockKeyhole size={12} className="mr-2 shrink-0" /> {ip}
              </div>
            ))
          ) : (
            <div className="flex items-center rounded border border-aegis-emerald/30 bg-aegis-emerald/10 px-2 py-1.5 font-mono text-xs text-aegis-emerald">
              <ShieldCheck size={12} className="mr-2 shrink-0" /> 无锁定来源 · no address banned
            </div>
          )}
        </div>
      </div>

      <button
        onClick={onExport}
        disabled={exporting}
        data-testid="export-daily-report-btn"
        className="flex w-full items-center justify-center rounded border border-aegis-cyan/40 raise py-2.5 font-mono text-xs text-aegis-cyan transition-colors hover:border-aegis-cyan/70 hover:bg-aegis-cyan/10 disabled:opacity-50"
      >
        <FileDown size={15} className="mr-2" />
        {exporting ? "GENERATING…" : "EXPORT DAILY REPORT .PDF"}
      </button>
    </section>
  );
}
